import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";

function AuthCallback() {
  const navigate = useNavigate();
  const { handleCallback, userStatus } = useAuth();
  const [error, setError] = useState(null);
  const [pending, setPending] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const errorParam = params.get("error");

    if (errorParam) {
      setError(errorParam);
      return;
    }

    if (code) {
      handleCallback(code)
        .then((response) => {
          const status = response?.user?.status;
          if (status === "approved") {
            navigate("/chat", { replace: true });
          } else {
            setPending(true);
          }
        })
        .catch((err) => setError(err.message || "Authentication failed"));
    } else {
      setError("No authorization code received");
    }
  }, [handleCallback, navigate]);

  if (error) {
    return (
      <div style={{ textAlign: "center", padding: "4rem" }}>
        <h2 style={{ color: "var(--color-danger)", marginBottom: "1rem" }}>
          Authentication Failed
        </h2>
        <p style={{ color: "var(--color-text-muted)", marginBottom: "2rem" }}>{error}</p>
        <button
          className="btn-primary"
          onClick={() => navigate("/auth", { replace: true })}
        >
          Try Again
        </button>
      </div>
    );
  }

  if (pending) {
    return (
      <div style={{ textAlign: "center", padding: "4rem", maxWidth: "480px", margin: "0 auto" }}>
        <div style={{ fontSize: "4rem", marginBottom: "1.5rem" }}>⏳</div>
        <h2 style={{ color: "var(--color-text)", marginBottom: "1rem", fontSize: "1.5rem" }}>
          Account Pending Approval
        </h2>
        <p style={{ color: "var(--color-text-muted)", lineHeight: "1.6", marginBottom: "2rem" }}>
          Your request has been submitted and is waiting for administrator approval.
          You'll be able to access Anna once your account is approved.
        </p>
        <button
          className="btn-primary"
          onClick={() => navigate("/auth", { replace: true })}
          style={{ padding: "0.75rem 1.5rem", borderRadius: "8px", border: "none", cursor: "pointer" }}
        >
          Back to Login
        </button>
      </div>
    );
  }

  return (
    <div style={{ textAlign: "center", padding: "4rem" }}>
      <p>Authenticating...</p>
    </div>
  );
}

export default AuthCallback;
